/* eslint-disable import/no-unused-modules */
import { ccFromSlug, nameFromSlug } from 'tf-post-parser';
import { GET_LOCATION_DETAILS } from '../../helpers/graphql/locations';
import { GET_ITINERARIES } from '../../helpers/graphql/itineraries';
import graphQLClient from '../../helpers/graphQLClient';
import withApollo from '../../lib/withApollo';
import DestinationShell from 'components/Destinations/DestinationShell';
import DestinationTravelGuide from 'components/Destinations/DestinationTravelGuide';
import LiveTravelGuide from 'components/Destinations/LiveTravelGuide';
import MiniTravelGuide from 'components/Destinations/MiniTravelGuide';

const DestinationsPage = ({ locationDetails, query, itineraries }) => {
  const { countryCode, country, suburb, city, subdivision } = query;

  const countryName = nameFromSlug(country);

  const title = `${
    (suburb && `${suburb}, ${city}`) ||
    (city && `${city}`) ||
    (subdivision && `${subdivision}`) ||
    countryName
  }`;

  const breadcrumbs = [];
  if (countryCode) {
    breadcrumbs.push(
      {
        position: 1,
        name: 'Travel Guides',
        item: `https://travelfeed.com/destinations`,
      },
      {
        position: 2,
        name: countryName,
        item: `https://travelfeed.com/destinations/${country}`,
      },
    );
  }
  if (subdivision) {
    breadcrumbs.push({
      position: 3,
      name: subdivision,
      item: `https://travelfeed.com/destinations/${country}/${subdivision}`,
    });
  }
  if (city) {
    breadcrumbs.push({
      position: 4,
      name: city,
      item: `https://travelfeed.com/destinations/${country}/${subdivision}/${city}`,
    });
  }

  return (
    <DestinationShell
      headerProps={{ subheader: title, active: 'destination' }}
      navOverPhoto={Boolean(
        locationDetails.currencies &&
          locationDetails.currencies.length > 0 &&
          locationDetails.image,
      )}
    >
      {locationDetails.currencies && locationDetails.currencies.length > 0 ? (
        <DestinationTravelGuide
          locationDetails={locationDetails}
          query={query}
          itineraries={itineraries}
          breadcrumbs={breadcrumbs}
        />
      ) : locationDetails.body ? (
        <MiniTravelGuide
          locationDetails={locationDetails}
          query={query}
          title={title}
          body={locationDetails.body}
          breadcrumbs={breadcrumbs}
          noIndex
        />
      ) : (
        <LiveTravelGuide
          locationDetails={locationDetails}
          query={query}
          title={title}
          breadcrumbs={breadcrumbs}
          noIndex
        />
      )}
    </DestinationShell>
  );
};

export async function getStaticProps({ params }) {
  const { destination } = params;
  const country = destination.length > 0 ? destination[0] : undefined;
  const subdivision = destination.length > 1 ? destination[1] : undefined;
  const city = destination.length > 2 ? destination[2] : undefined;
  const suburb = destination.length > 3 ? destination[3] : undefined;

  const countryCode = ccFromSlug(country);

  if (!countryCode) return { notFound: true, revalidate: 10 };

  const query = {
    limit: 9,
    orderby: 'score',
    language: 'en',
    countryCode,
    country,
    subdivision: subdivision || null,
    city: city || null,
    suburb: suburb || null,
  };
  if (countryCode && !subdivision) query.orderby = 'countryScore';
  else if (countryCode && subdivision && !city)
    query.orderby = 'subdivisionScore';

  try {
    const fetchDestination = await graphQLClient(GET_LOCATION_DETAILS, query);

    if (!fetchDestination || !fetchDestination.locationDetails)
      return { notFound: true, revalidate: 10 };

    const itineraries = await graphQLClient(GET_ITINERARIES, {
      countryCode,
    });

    return {
      props: {
        locationDetails: fetchDestination.locationDetails,
        query,
        itineraries: itineraries ? itineraries.itineraries : [],
      },
      revalidate: 10,
    };
  } catch {
    return { notFound: true, revalidate: 10 };
  }
}

export async function getStaticPaths() {
  return { paths: [], fallback: 'blocking' };
}

export default withApollo(DestinationsPage);
